// src/components/ServiceList.js

import React from 'react';
import { motion } from 'framer-motion';

const SERVICE_LABELS = {
  podolatria: 'Podolatria',
  sexo_anal: 'Sexo anal',
  sexo_oral: 'Sexo oral',
  massagem: 'Massagem relaxante',
  companhia: 'Companhia para eventos',
  roleplay: 'Roleplay/Fantasia',
  bdsm: 'BDSM',
  striptease: 'Striptease',
  masturbacao: 'Masturbação',
  sexovirtual: 'Sexo virtual',
  sexovaginal: 'Sexo vaginal',
  beijoboca: 'Beijo na boca',
  // adicione aqui todos os serviços que a GP definiu...
};

const LeftArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M9.707 4.293a1 1 0 00-1.414 1.414L11.586 8H4a1 1 0 100 2h7.586l-3.293 3.293a1 1 0 001.414 1.414l5-5a1 1 0 000-1.414l-5-5z" clipRule="evenodd" />
  </svg>
);

const RightArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L13.586 11H4a1 1 0 110-2h9.586l-3.293-3.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
  </svg>
);

export default function ServiceList({ services = {}, onComplete, onBack }) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-gray-900">Serviços Disponíveis</h2>
        <p className="text-gray-600 mt-1">Serviços oferecidos</p>
      </div>

      <div className="space-y-3 sm:space-y-4">
        {Object.entries(SERVICE_LABELS).map(([key, label]) => (
          <motion.div
            key={key}
            whileHover={{ scale: 1.01 }}
            className={`p-4 bg-white rounded-xl border transition-all duration-200 ${
              services[key] 
                ? 'border-[#e91e63]/50 bg-[#e91e63]/5 shadow-sm' 
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center space-x-4">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                services[key] ? 'bg-[#e91e63]/10' : 'bg-gray-100'
              }`}>
                <svg 
                  className={`w-6 h-6 ${services[key] ? 'text-[#e91e63]' : 'text-gray-400'}`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth="2" 
                    d="M5 13l4 4L19 7" 
                  />
                </svg>
              </div>
              <div>
                <h3 className="font-medium text-gray-900 text-lg">{label}</h3>
                <p className="text-sm text-gray-500">
                  {services[key] ? 'Serviço oferecido' : 'Serviço não oferecido'}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="flex justify-between pt-6">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onBack}
          className="px-6 py-3 text-gray-600 hover:text-gray-800 transition-colors flex items-center"
        >
          <LeftArrow /> Voltar
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onComplete}
          className="px-8 py-3 bg-[#e91e63] text-white rounded-xl hover:bg-[#d81557] transition-colors flex items-center"
        >
          Continuar <RightArrow />
        </motion.button>
      </div>
    </div>
  );
}
